import React, { Component } from 'react';
import injectTapEventPlugin from 'react-tap-event-plugin';
import Content from './Content';
import Navigation from './Navigation';
import Icon from './SvgIcon';
import Login from './Login';
import Loading from './Loading';
import { every } from 'underscore';
import 'core-js/es6/symbol';
import 'core-js/es6/array';
import './App.css';

injectTapEventPlugin();
const INDEX_DATA = window.INDEX_DATA;
const firebase = window.firebase;
const $ = window.$;
let F_USER = {};
let searchTextArr = [];
let datFileTotal = 0;
let datFileLoaded = 0;
window.isVideoPlaying = false;
window.videoRateStore = 1;

const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
const eventer = window[eventMethod];
const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalId:0,
      nowId:0,
      isMenu: false,
      indexData:[{src:"contents/"}],
      isLogin: true,
      isfirstinit:false,
      isDatLoaded: false,
      datFileLoaded: 0,
      suspend:[],
      indexDataNum:[],
      searchTextArr:[]
    }
    this.changePage = this.changePage.bind(this);
    this.setSuspend = this.setSuspend.bind(this);
    this.toggleNav = this.toggleNav.bind(this);
    this.init = this.init.bind(this);
    this.handleFrameTasks = this.handleFrameTasks.bind(this);
    this.autoNext = this.autoNext.bind(this);
    this.autoPrev = this.autoPrev.bind(this);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.loginCheck = this.loginCheck.bind(this);
    this.contentLoaded = this.contentLoaded.bind(this);
  }
  componentDidMount() {
    // firebaseの場合
    if(firebase){
      F_USER = {
        uname: "",
        psw: ""
      }
      return;
    }
    // this.setState({isLogin: true});
    eventer(messageEvent, this.handleFrameTasks);
    // 初期化関数
    window.contentLoaded(this.init);
  }

  // 検索用datファイルをそれぞれ読み込む
  datfileload(indexdata,index){
    let url = "";
    if(indexdata.type === "video"){
      url = indexdata.src.replace(/\/index.+/g, '');
      url = url + "/dat/ctrl.js";
      datFileTotal++;
    }else if(indexdata.type === "quiz"){
      url = indexdata.src.replace(/\/index.+/g, '');
      url = url + "/dat/quiz.js";
      datFileTotal++;
    }else if(indexdata.type === "page"){
      url = indexdata.src.replace(/\/index.+/g, '');
      url = url + "/dat/quiz.js";
      datFileTotal++;
    }else{
      //何もない時
      // searchTextArr[index] = null;
      datFileTotal++;
      datFileLoaded++;
      return;
    }
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.src = url;
    s.onload = () =>{
      if(indexdata.type === "video"){
        searchTextArr[index] = window.myData.caption;
      }else if(indexdata.type === "quiz"){
        searchTextArr[index] = [window.QUIZ_DATA[0].title, ...window.QUIZ_DATA[0].select];
      }else if(indexdata.type === "page"){
        searchTextArr[index] = [window.PAGE_DATA[0].title, ...window.PAGE_DATA[0].pages];
      }
      datFileLoaded++;
      if(datFileLoaded === datFileTotal){
        setTimeout(()=>{

           this.setState({
            isDatLoaded: true,
            searchTextArr:searchTextArr
          });
        }, 800);
        // console.log("dat ファイル　ロード完了");
      }
      this.setState({
        datFileLoaded: datFileLoaded
      });
    }
    document.body.appendChild(s);
  }
  contentLoaded(){
    // 初めのコンテンツがロードされた

    if(!this.state.isfirstinit){
      this.setState({
        isfirstinit: true
      })
    }
  }
  init() {

    window.onunload = () => {
      this.setSuspend();
      window.contentUnload();
    };
    // console.log(INDEX_DATA);
    // 配列をsuspendに挿入
    let tmp = [];
    let tmp_index=[];
    let tmp_num=[];
    let total = 0;
    // タイトル挿入
    document.title = INDEX_DATA[0].title;


    INDEX_DATA[0].contents.forEach((parent,index) => {
      if(parent.contents){
        // tmp[index] = [];
        tmp_num[index] = [];
        parent.contents.forEach((child, cindex) => {
          if(child.contents){
            //
            // tmp[index][cindex] = [];
            tmp_num[index][cindex] = [];
            child.contents.forEach((exchild) => {
              if(exchild.contents){
                //
                console.log("4階層以上あります！！！！");
              }else{
                // tmp[index][cindex].push(0);
                this.datfileload(exchild,total);
                tmp.push(0);
                tmp_index.push(exchild);
                tmp_num[index][cindex].push(total +1);
                total++;
              }
            })

          }else{
            // tmp[index].push(0);
            this.datfileload(child,total);
            tmp.push(0);
            tmp_index.push(child);
            total++;
            tmp_num[index][cindex] = total;
          }
        })
      }else {
        // tmp[index] = 0;
        this.datfileload(parent,total);
        tmp.push(0);
        tmp_index.push(parent);
        total++;
        tmp_num[index] = total;
      }
    });

    let nowId = 0;
    if(window.SUSPEND !== ''){
      let arr = window.SUSPEND.split(',');
      let count = 0;
      for (let value of arr[0]) {
        // console.log(value);
        tmp[count] = Number(value);
        count++;
      }
      nowId = Number(arr[1]);
    }
    $(".preLoading").remove();
    this.setState({totalId: total, suspend:tmp, indexData: tmp_index, indexDataNum:tmp_num, nowId: nowId});
  }

  handleFrameTasks(e){
    const key = e.message ? 'message' : 'data';
    const data = e[key];
    const tmp = this.state.suspend;

    if (data === 'onCompleteVideo') {
      // console.log(data);
      tmp[this.state.nowId] = 1;
      this.setState({suspend: tmp});
      this.setSuspend();
    } else if (data === 'onQuizComplete') {
      // console.log(data);
      if(tmp[this.state.nowId] === 0){
        tmp[this.state.nowId] = 1;
      }
      this.setSuspend();
      this.setState({suspend: tmp});
      if(this.state.indexData[this.state.nowId].autoPlay){
        this.autoNext();
      }
    }else if (data === 'onQuizPassed') {
      // console.log(data);
      tmp[this.state.nowId] = 2;
      this.setState({suspend: tmp});
    }else if (data === 'onQuizFailed') {
      // console.log(data);
      tmp[this.state.nowId] = 3;
      this.setState({suspend: tmp});
    } else if (data === 'onPrevVideo') {
      // console.log(data);
      this.autoPrev();
    }else if (data === 'onNextVideo') {
      if(this.state.indexData[this.state.nowId].autoPlay){
          this.autoNext();
      }
    } else if (data === 'onVideoPlay') {
      console.log(data);
      window.isVideoPlaying = true;
      this.setSuspend();
    } else if (data === 'onVideoPause') {
      console.log(data);
      window.isVideoPlaying = false;
    }　
  }

  setSuspend(){
    // コンテンツ修了かチェック
    let progress = 0;
    this.state.suspend.forEach(function(value, index) {
        if(value > 0) {
          progress = progress + 1;
        }
    });
    window.PROGRESS = Math.floor((progress / this.state.totalId) * 100);
    // SCORM通信
    window.setSuspendData(String(this.state.suspend.join(''))+','+this.state.nowId);

    const isCompleteContent = this.state.suspend.every(
      (ele)=>{
        return ele > 0;
      }
    );
    if(isCompleteContent){
      window.contentComplete();
    }
  }

  changePage(el){
    //nav
    // console.log(el);
    this.toggleNav(false);
    const NOWID = Number(el.id.split('click').join("")) - 1;
    this.setState({nowId: NOWID});
  }

  autoNext() {
    if(this.state.nowId < this.state.totalId - 1){
      const nextId = this.state.nowId + 1;
      this.setState({nowId: nextId});
    }
  }

  autoPrev() {
    // console.log(this.state.nowId);
    if(this.state.nowId > 0){
      const prevId = this.state.nowId - 1;
      this.setState({nowId: prevId});
    }
  }

  toggleNav(bool){
    this.setState({isMenu: bool});
  }

  // firebase
  //
  handleInputChange(e){
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    F_USER[name] = value;
  }
  loginCheck(){
    firebase.auth().signInWithEmailAndPassword(F_USER.uname, F_USER.psw).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // ...
      console.log(errorCode, errorMessage);
    });
  }
  render() {
    let readedNum = 0;
    let totalreaded = 0;
    this.state.indexDataNum.forEach((child) => {
      if(typeof child === 'object'){
        child.forEach((num) => {
          if(typeof num === 'object'){
            if(every(num, (id) => {return this.state.suspend[id-1] > 0;})){
              readedNum += 1;
            }
            totalreaded +=1
            return;
          }else{
            if(this.state.suspend[num-1] > 0){
              readedNum += 1;
            }
            totalreaded +=1;
          }
        })
      }else{
        if(this.state.suspend[child-1] > 0){
          readedNum += 1;
        }
        totalreaded +=1;
      }
    });
    let restNum = totalreaded - readedNum;
    if(!this.state.isDatLoaded){
      return (
        <div className="App">
          <Loading isDatLoaded={this.state.isDatLoaded} total={datFileTotal} loadedNum={this.state.datFileLoaded}/>;
        </div>
      );
    }
    if(this.state.isLogin){
      return (
        <div className={this.state.isfirstinit ? "App loaded":"App"}>
          <div className="cd-nav-trigger" onClick={(e) => {e.stopPropagation();e.preventDefault(); this.toggleNav(true)}}>
            <p className="cd-nav-trigger-index">目次・検索</p>
            <div className={restNum === 0 ? "suspend-num hidden" : "suspend-num"}><p>{`残り：${restNum}`}</p></div>
          </div>
          <Navigation data={INDEX_DATA} id={this.state.nowId} suspend={this.state.suspend} total={totalreaded} toggleNav={() => {this.toggleNav(false);}} searchArr={this.state.searchTextArr} isMenu={this.state.isMenu} changePage={this.changePage} restNum={restNum} indexDataNum={this.state.indexDataNum} isDatLoaded={this.state.isDatLoaded} />
          <Content id={this.state.nowId} src={this.state.indexData[this.state.nowId].src} isMenu={this.state.isMenu} autoNext={this.autoNext} contentLoaded={this.contentLoaded} />
          <div className={this.state.isMenu ? "menu-overlay is-visible" : "menu-overlay"} onClick={(e) => {e.preventDefault();this.toggleNav(false)}}></div>
        </div>
      );
    }else{
      return (
        <div className="App">
          <Login loginCheck={this.loginCheck} handleInputChange={this.handleInputChange}/>
        </div>
      );
    }

  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js